import PasswordInputField from "../../../../_utils/CommonInputFields/PasswordInputField";
import TextInputField from "../../../../_utils/CommonInputFields/TextInputField";

const LoginDetails = ({
  handleChange,
  userPayload,
  setUserPayload,
  selectedValue,
  showUserId = true,
  showPassword = true,
  type = false,
}) => {
  return (
    <div className="flex flex-col relative w-width-full mt-margin-md">
      <div className="p-padding-md bg-primary-card flex flex-col rounded-border-radius-md">
        <div className="w-width-full flex flex-col gap-gap-md">
          <div className="text-text-primary font-semibold text-base">
            {type === "my_profile" ? "Login Details" : "User Details"}
          </div>
          <div className="flex flex-col gap-gap-md">
            {showUserId && (
              <div>
                <TextInputField
                  variant={"default"}
                  placeholder="User ID"
                  bgColor="var(--primary-card)"
                  fgColor="var(--text-primary)"
                  value={userPayload?.user_id}
                  name="user_id"
                  onInput={(e) => {
                    handleChange(e);
                  }}
                  isFullWidth={true}
                  adornment=""
                />
              </div>
            )}
            <div>
              <TextInputField
                variant={"default"}
                placeholder="Alias"
                bgColor="var(--primary-card)"
                fgColor="var(--text-primary)"
                value={userPayload?.alias}
                name="alias"
                onInput={(e) => {
                  handleChange(e);
                }}
                isFullWidth={true}
                adornment=""
              />
            </div>
            {showPassword && (
              <div>
                <PasswordInputField
                  bgColor="var(--primary-card)"
                  fgColor="var(--text-primary)"
                  placeholder="Password"
                  variant={"default"}
                  fontKind="big"
                  value={userPayload?.password}
                  onInput={(e) => {
                    handleChange(e);
                  }}
                  name="password"
                  isFullWidth={true}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginDetails;
